import { render } from "./ObjectShowIFrame.vue?vue&type=template&id=33ef3912&ts=true"
import script from "./ObjectShowIFrame.ts?vue&type=script&lang=ts&external"
export * from "./ObjectShowIFrame.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__